import React from 'react';
import { useTranslation } from 'react-i18next';
import { LineChart } from '@oliasoft-open-source/charts-library';
import { connect } from 'react-redux';
import translations from 'src/internationalisation/translation-map.json';
import { displayNumber } from '@oliasoft-open-source/units';
import { generateActualChartLine } from 'src/views/time-tracker/utils/generate-actual-chart-line';
import { selectUnitByQuantity } from 'store/entities/unit-templates/selectors';
import { QuantitiesTypes } from 'src/enums/unit-templates';
import { CHART_MEDIUM_NEUTRAL_COLOR, CHART_PRIMARY_COLOR, getScatterChartPoints } from 'views/simulations/simulations';

const Plot = ({ estimates, controlsPortalId, depthUnit, currentEstimate }) => {
  const { t } = useTranslation();

  const datasets = estimates
    .map((estimate) => {
      let data = [];
      if (estimate.timeTracker) {
        data = generateActualChartLine(estimate.timeTracker, t, translations, depthUnit)?.data;
      }

      return {
        borderColor: CHART_MEDIUM_NEUTRAL_COLOR,
        pointBackgroundColor: CHART_MEDIUM_NEUTRAL_COLOR,
        label: estimate.name,
        data,
      };
    })
    .filter((item) => item);

  const currentDataset = {
    borderColor: CHART_PRIMARY_COLOR,
    pointBackgroundColor: CHART_PRIMARY_COLOR,
    label: currentEstimate.name,
    data: getScatterChartPoints(currentEstimate.simulationResult?.operation_vs_depth?.mean, 0, depthUnit),
  };
  datasets.push(currentDataset);

  const chartOptions = {
    controlsPortalId,
    data: {
      datasets,
    },
    options: {
      chartStyling: {
        height: '550px',
      },
      additionalAxesOptions: {
        reverse: true,
      },
      scales: {
        x: {
          ticks: {
            callback: (val) => {
              return displayNumber(val, { scientific: false });
            },
          },
        },
      },
      tooltip: {
        scientificNotation: false,
      },
      axes: {
        x: [
          {
            label: t(translations.time),
          },
        ],
        y: [
          {
            label: `${t(translations.depth)} [${depthUnit}]`,
          },
        ],
      },
    },
  };

  return <LineChart chart={chartOptions} />;
};

const mapStateToProps = ({ entities }) => {
  return {
    depthUnit: selectUnitByQuantity(entities, QuantitiesTypes.Depth),
  };
};

const Container = connect(mapStateToProps)(Plot);

export { Container as Plot };
